import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface Props {
    /** Label(좌) + Control(우) 행 구조로 그린다. leftText/rightText 와 함께 쓰지 않는다. */
    label?: string;
    leftText?: string;
    rightText?: string;
    checked?: boolean;
    setChecked?: (v: boolean) => void;
    canDisabled?: boolean;
}

function Switch({
    label, leftText, rightText, checked, setChecked, canDisabled,
}:Props) {
    const isDisabled = canDisabled && (!checked);
    const control = (
        <Container isDisabled={isDisabled}
            isChecked={checked}
            onClick={() => setChecked?.(!checked)}>
            <Handle isChecked={checked} />
        </Container>
    );
    if (label) {
        return (
            <LabelRow>
                <Text color={colors.textPrimary}>{label}</Text>
                {control}
            </LabelRow>
        );
    }
    return (
        <Row spacing={2}>
            {leftText && (
                <Text color={colors.gray7}
                    fontWeight={checked ? 'regular' : 'bold'}
                >
                    {leftText}
                </Text>
            )}
            {control}
            {rightText && (
                <Text color={colors.gray7}
                    fontWeight={checked ? 'bold' : 'regular'}
                >
                    {rightText}
                </Text>
            )}
        </Row>
    );
}

const LabelRow = styled.div`
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: space-between;
    width: 100%;
`;

const Container = styled.div<{
    isDisabled?: boolean;
    isChecked?: boolean;
}>`
    background-color: var(--color-background-raised);
    border-radius: 12px;
    height: 24px;
    width: 46px;
    display: flex;
    align-items: center;
    flex: none;
    transition: 100ms;
    ${({ isDisabled }) => isDisabled && css`
        background-color: var(--color-button-disabled);
    `}
    ${({ isChecked }) => isChecked && css`
        background-color: var(--color-secondary);
    `}
`;

const Handle = styled.div<{
    isChecked?: boolean;
}>`
    border-radius: 12px;
    transition: 100ms;
    width: 20px;
    height: 20px;
    margin-left: 2px;
    background-color: var(--color-icon-unselected);
    ${({ isChecked }) => isChecked && css`
        background-color: var(--color-primary);
        transform: translateX(22px);
    `}
`;

export default Switch;
